export function formatLabel(text){
  return text
    .split(/[_\s]+/) // split on underscores or whitespace
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}